export default {
  scheduled_order: 'Encomenda Agendada',
  show_more: 'Mostrar mais',
  show_less: 'Mostrar menos',
  schedule_order: 'Agendar encomenda',
};
